var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsEnum, IsInt, IsOptional, IsString, Max, Min } from 'class-validator';
import { NotificationLane } from '../enum/notification-lane.enum.js';
/** Default page size of `GET /users/:userId/notifications`. */
export const NOTIFICATION_PAGE_SIZE = 15;
/**
 * Query of `GET /users/:userId/notifications`.
 *
 * Deliberately a class and not an inline type: `validationOptions` runs with
 * `forbidNonWhitelisted`, which only bites once there is a metatype to whitelist
 * against — so declaring it here is what makes the withdrawn `skip`/`take`
 * offset parameters, and the withdrawn `read` flag (RS-005), a 400 rather than
 * something silently ignored.
 */
export class GetNotificationsQueryDto {
    /**
     * Opaque continuation token from the previous page's `nextCursor`. Absent for
     * the first page. Its contents are an implementation detail of the server —
     * clients only ever hand back what they were given.
     */
    cursor;
    limit;
    /**
     * Which half of the Posteingang to page. Absent means `OPEN` — the queue is
     * what the Posteingang is, and the archive is the view you have to ask for.
     */
    lane;
}
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], GetNotificationsQueryDto.prototype, "cursor", void 0);
__decorate([
    IsOptional(),
    Type(() => Number),
    IsInt(),
    Min(1),
    Max(100),
    __metadata("design:type", Number)
], GetNotificationsQueryDto.prototype, "limit", void 0);
__decorate([
    IsOptional(),
    IsEnum(NotificationLane),
    __metadata("design:type", String)
], GetNotificationsQueryDto.prototype, "lane", void 0);
//# sourceMappingURL=get-notifications-query.dto.js.map